import api from "./api-service";

class OmrService {
  getSampleJsonUrl() {
    const base = process.env.VUE_APP_QUIZ_SERVICE_URL || "";
    return `${base.replace(/\/$/, "")}/omr/sample-json`;
  }

  importJsonToQuiz(quizId, formData) {
    return api.post({
      url: `quiz/import-omr-json/${quizId}`,
      body: formData,
    });
  }

  exportQuizJson(quizId) {
    return api.get({
      url: `quiz/export-omr-json/${quizId}`,
    });
  }

  getResultsDashboard(quizId) {
    return api.get({
      url: `omr/admin/quiz/${quizId}/results-dashboard`,
    });
  }
}

export default new OmrService();
